import { Api } from './Api';
import config from 'helpers/config';

export * from './fetchJSON';

const ApiLearning = new Api(config.apiUrl);

export { ApiLearning };
